module.exports = __webpack_public_path__ + "img/nwu-logo.13a466ee.png";